import { Metric } from '../metric/metric';
import { PageLoadMetric } from '../metric/page-load-metric';
import { PageSegmentLoadMetric } from '../metric/page-segment-load';
import { BMEventsType } from '../types';
export const pageLoad = config => {
  return new PageLoadMetric({ ...config,
    type: BMEventsType.PAGE_LOAD
  });
};
export const pageSegmentLoad = config => {
  return new PageSegmentLoadMetric({ ...config,
    type: BMEventsType.PAGE_SEGMENT_LOAD
  });
};
export const interaction = config => {
  return new Metric({ ...config,
    type: BMEventsType.INLINE_RESULT
  });
};
export const custom = config => {
  return new Metric({ ...config,
    type: BMEventsType.CUSTOM
  });
};